// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"bdad15d5","227":"c34705e5","228":"3ba6a1e6","416":"b191107a","514":"0b26ac45","522":"cf46b74a","618":"f20bba03","693":"25ecca7f","714":"c1aee392","818":"2640bf92","824":"7779b28d","927":"3f4f98b2"}[chunkId] + ".chunk.js";
};